












import Vue from 'vue';
import { BFormCheckbox } from 'bootstrap-vue';

export default Vue.extend({
  name: 'EditCardCheckbox',
  components: {
    BFormCheckbox,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: 'No',
    },
  },
  computed: {
    booleanValue(): boolean {
      return this.value === 'Yes';
    },
  },
  created() {
    if (this.value !== 'Yes') {
      this.$emit('input', 'No');
    }
  },
});
